import React, {useEffect, useState} from 'react';

import {Formik, Field, Form, ErrorMessage, useFormik} from 'formik';
import {alertService} from '@app/services/alertService';
//import {nhaphanphoiService} from '@app/services/nhaphanphoiService';
import Select from 'react-select';
import * as mainService from '@app/services/mainService';
import {useLocation} from 'react-router-dom';
import {getControllerName, getDefaultSelectValue} from '@app/utils/helpers';
import HeaderClick from '@app/utils/HeaderClick';
import {checkRole} from '@app/services/mainService';
import { myService } from "@app/services/phanquyenService";
import {Button} from "react-bootstrap";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import TrangthaiListComponent from '@app/pages/FUtil/TrangthaiListComponent';
import {INIT_ROLE_MENU} from "@app/const/AppSetting";
import {ClipLoader} from "react-spinners";
function PhanquyenEdit({history, match}) {
    const [t] = useTranslation();
    const location = useLocation();

    const currController = getControllerName(location.pathname);
    const [loading, setLoading] = useState(false);

    const initArr = [];
    let {id} = match.params;
    let isAddMode = !id;
    const isDisplay = id && location.pathname.indexOf(`view`) > 0;


    const [handleToogle, setHandleToogle] = useState(false);
    const [hasRole, setHasRole] = useState(false);
    const [roleMenu, setRoleMenu] = useState(INIT_ROLE_MENU);

    const initial = {
        menu_fks: [],
        id: id,
        ten: '',
        trangthai_fk: 1
    };
    const [obj, setObj] = useState({...initial});
    const onChangeInput = (e) => {
        const {name, value} = e.target;
        //  console.log(name);
        //   console.log(value);
        setObj((prevState) => ({
            ...prevState,
            [name]: value
        }));

    };

    const [menuRs, setMenuRs] = useState(initArr);
    const [quyenCheck, setQuyenCheck] = useState(menuRs.map(item => ({ menu_parent : item.id,parent : '', tenmenu :'',menu_fk: item.id, all: 0, quyenbaocao: 0, quyenchinhsua: 0, quyenchot: 0
        , quyenhienthi: 0, quyenin: 0, quyenmochot: 0 , quyentaomoi: 0 , quyenxoa: 0 })));
  

    async function createUser(data) {
       setLoading(true);
               // delete data.ma;
               const result = await myService.Create(data);
               if (result.status ==="1") {
                   alertService.success(result.msg);
                   
                   history.push('/'+currController);
       
               } else {
                   alertService.error(result.msg);
               }
               setLoading(false);
    }

    async function updateUser(id, data) {
        setLoading(true);
             
               const result = await myService.Update(id,data);
               if (result.status ==="1") {
                   alertService.success(result.msg);
                 
               } else {
                   alertService.error(result.msg);
               }
               setLoading(false);
    }
    const createRs = async () => {

        if (!hasRole) {
            const role = await mainService.getRoleMENU(location.pathname);
            setRoleMenu(role);
            setHasRole(true);
        }
        const myMenuX = await mainService.showMenuRole();
        setMenuRs(myMenuX);

        let menuCheck = [];

        myMenuX.forEach((menu) => {

            let childs = menu.children;
            childs.forEach((m2) => {
                //console.log(m2);
                let m = { menu_parent: menu.id,parent: menu.name,menu_fk: m2.id, tenmenu: m2.name, all:0, quyenbaocao: 0, quyenchinhsua: 0
                    , quyenchot: 0, quyenhienthi: 0, quyenin: 0, quyenmochot: 0 , quyentaomoi: 0 , quyenxoa: 0 };
                menuCheck.push(m);

            });

        });
        setQuyenCheck(menuCheck);

     

        if (!isAddMode) {
            myService.getById(id).then((response) => {
                //console.log('getById', JSON.stringify(response, null, 2));
                const userX = response.data.data;
                setObj(userX);

                // Merge quyền từ DB vào danh sách menu
                const updatedMenuCheck = menuCheck.map(menu => {
                    const dbMenu = userX.menu_fks.find(dbItem => dbItem.menu_fk === menu.menu_fk);
                    return dbMenu ? { ...menu, ...dbMenu } : menu;
                });

                setQuyenCheck(updatedMenuCheck);

                //setQuyenCheck(userX.menu_fks.map(obj=> ({ ...obj, all: 0 })));
            });
        }

    };

    useEffect(async () => {
        await checkRole({
            pathname: location.pathname,
            isAddMode,
            currController,
            history
        });
        await createRs();

    }, []);

    const chonPK = (position,name) => {

        let q = quyenCheck;
        if(name ==='all')
        {
            const quyenAll = quyenCheck[position].all === 0 ? 1 : 0;
            q[position].quyenbaocao = quyenAll;
            q[position].quyenchinhsua = quyenAll;
            q[position].quyenchot = quyenAll;
            q[position].quyenhienthi = quyenAll;
            q[position].quyenin = quyenAll;
            q[position].quyenmochot = quyenAll;
            q[position].quyentaomoi = quyenAll;
            q[position].quyenxoa = quyenAll;
            q[position].all = quyenAll;
        }
        else
        {
            q[position][name] = quyenCheck[position][name]=== 0 ? 1 : 0;
        }
        setQuyenCheck(q);
        setHandleToogle((prevSelected) => {
            return !prevSelected;
        });

    };

    const taoPKClick = () => {

        let data = obj;
        data.menu_fks= quyenCheck;

       // data.nppIds =  nppCheck.filter(item => item.checked === true).map(res => ({id: res.id}));

      //  console.log('phienkham', JSON.stringify(obj, null, 2));
        if(isAddMode)
        {
            createUser(data);
        }
        else
        {
            updateUser(id,data);
        }
    };

    if (loading) {
        return (
            <div className="flex justify-center items-center h-40">
                <ClipLoader color="#3498db" size={50} />
            </div>
        );
    }

    let htmlButtonSave = '';
    if(isDisplay <= 0 || isAddMode > 0){
        htmlButtonSave = (
            <Button
                className="btn  btn-success  mr-1"

                icon="right fas fa-angle-left"
                onClick={taoPKClick}
            >
                <i className="fa fa-save"> {isAddMode>0 ? "Tạo mới" :"Cập nhật"  } </i>
            </Button>
        );

    }

    const backBrowse = () => {
        history.push('/'+currController);
    };

    // eslint-disable-next-line no-shadow
    return (

        <div className="card card-primary">
            <HeaderClick
                headerName={roleMenu.tenmenu}
                isAddMode={isAddMode}
                isDisplay={isDisplay}
                history={history}
                currController={currController}
            />
            <div className="card-body">
                <div className="form-row p-2">
                    <Button className="btn btn-secondary mr-1" onClick={() => backBrowse()}>
                        <i className="fa fa-arrow-circle-left"> {t('action.label.back')}</i>
                    </Button>
                    {htmlButtonSave}
                </div>
            </div>

            <div className="card-body">
                <div className="row">

                    <div className="col-md-6">
                        <label htmlFor="ten">Tên nhóm quyền</label>
                        <input
                            id="ten"
                            name="ten"
                            type="text"
                            className="form-control"
                            value={obj.ten}
                            onChange={onChangeInput}
                        />
                    </div>
                    <div className="col-md-6">
                    <TrangthaiListComponent trangthai_fk = {obj.trangthai_fk} 
                                     onChange={(opt, e) => {
                                        const target = {name: "trangthai_fk", value: opt?.value};
                                        onChangeInput({target});
                                    }}
                                    filterIds = { [0,1] }
                                    trangthaiName = "name"
                                />        

                        
                    </div>
                </div>
                <hr/>


                <div className="row table-responsive">
                    <div className="col-md-12">
                        <table responsive bordered hover className="table table-bordered table-hover text-nowrap">
                            <thead>
                            <tr>
                                <th className="col-md-2 text-center" colspan="2">MENU</th>
                                <th className="col-md-1 text-center">TẠO MỚI</th>
                                <th className="col-md-1 text-center">SỬA</th>
                                <th className="col-md-1 text-center">XÓA</th>
                                <th className="col-md-1 text-center">XEM</th>
                                <th className="col-md-1 text-center">DUYỆT</th>
                                <th className="col-md-1 text-center">HỦY DUYỆT</th>
                                <th className="col-md-1 text-center">IN</th>
                                <th className="col-md-1 text-center">BÁO CÁO</th>
                            </tr>
                            </thead>
                            <tbody>

                            {
                                quyenCheck.map((item, index) => {

                                    return (
                                        <tr>
                                            <td>{item.parent}</td>
                                            <td>{item.tenmenu}
                                                &nbsp;&nbsp; <input type="checkbox" id={`custom-checkbox-${index }`}
                                                       value={item.menu_fk}
                                                       checked={ quyenCheck[index]?.all===1}
                                                       onChange={() => chonPK(index,'all')}
                                                />
                                            </td>
                                            <td className="text-center">
                                                <input type="checkbox" id={`custom-checkbox-${index }`}
                                                       value={item.menu_fk}
                                                       checked={ quyenCheck[index]?.quyentaomoi===1}
                                                       onChange={() => chonPK(index,'quyentaomoi')}
                                                />
                                            </td>
                                            <td  className="text-center">
                                                <input type="checkbox" id={`custom-checkbox-${index }`}
                                                       value={item.menu_fk}
                                                       checked={ quyenCheck[index]?.quyenchinhsua===1}
                                                       onChange={() => chonPK(index,'quyenchinhsua')}
                                                />
                                            </td>
                                            <td  className="text-center">
                                                <input type="checkbox" id={`custom-checkbox-${index }`}
                                                       value={item.menu_fk}
                                                       checked={ quyenCheck[index]?.quyenxoa===1}
                                                       onChange={() => chonPK(index,'quyenxoa')}
                                                />
                                            </td>
                                            <td  className="text-center">
                                                <input type="checkbox" id={`custom-checkbox-${index }`}
                                                       value={item.menu_fk}
                                                       checked={ quyenCheck[index]?.quyenhienthi===1}
                                                       onChange={() => chonPK(index,'quyenhienthi')}
                                                />
                                            </td>
                                            <td  className="text-center">
                                                <input type="checkbox" id={`custom-checkbox-${index }`}
                                                       value={item.menu_fk}
                                                       checked={ quyenCheck[index]?.quyenchot===1}
                                                       onChange={() => chonPK(index,'quyenchot')}
                                                />
                                            </td>
                                            <td  className="text-center">
                                                <input type="checkbox" id={`custom-checkbox-${index }`}
                                                       value={item.menu_fk}
                                                       checked={ quyenCheck[index]?.quyenmochot===1}
                                                       onChange={() => chonPK(index,'quyenmochot')}
                                                />
                                            </td>
                                            <td  className="text-center">
                                                <input type="checkbox" id={`custom-checkbox-${index }`}
                                                       value={item.menu_fk}
                                                       checked={ quyenCheck[index]?.quyenin===1}
                                                       onChange={() => chonPK(index,'quyenin')}
                                                />
                                            </td>
                                            <td  className="text-center">
                                                <input type="checkbox" id={`custom-checkbox-${index }`}
                                                       value={item.menu_fk}
                                                       checked={ quyenCheck[index]?.quyenbaocao===1}
                                                       onChange={() => chonPK(index,'quyenbaocao')}
                                                />
                                            </td>
                                        </tr>
                                    );


                                })

                            }
                            </tbody>
                        </table>
                </div>
            </div>
            <div className="card-footer">
                <div className="form-row p-2">
                    <Button className="btn btn-secondary mr-1" onClick={() => backBrowse()}>
                        <i className="fa fa-arrow-circle-left"> {t('action.label.back')}</i>
                    </Button>
                    {htmlButtonSave}
                </div>
            </div>

            </div>



        </div>
    );
}

export {PhanquyenEdit};
